module.exports = __webpack_public_path__ + "static/img/金融背景@3x.7bd5697.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/供应链金融/金融背景@3x.png
// module id = cDbW
// module chunks = 192